"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankName = void 0;
var BankName;
(function (BankName) {
    BankName["BancoDoBrasil"] = "BANCO DO BRASIL S.A.";
    BankName["Bancoob"] = "BANCO COOPERATIVO DO BRASIL S.A.";
    BankName["Banrinsul"] = "BANCO DO ESTADO DO RIO GRANDE DO SUL S.A.";
    BankName["Bradesco"] = "BANCO BRADESCO S.A.";
    BankName["Inter"] = "BANCO INTERMEDIUM S.A.";
    BankName["Itau"] = "BANCO ITAU S.A.";
    BankName["Original"] = "BANCO ORIGINAL";
    BankName["Santander"] = "BANCO SANTANDER";
    BankName["Sicredi"] = "BANSICREDI";
})(BankName = exports.BankName || (exports.BankName = {}));
//# sourceMappingURL=BankName.js.map